// extracted by mini-css-extract-plugin
export default {"mn-style-item":"index_mn-style-item__nrAD9"};